import { withTranslation } from "i18n";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { Alert, Button, Spinner } from "react-bootstrap";
import { CircularProgressbar } from "react-circular-progressbar";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import {
  getResultsStartAsync,
  getStundetPointsStartAsync,
  resetResultOffset
} from "redux/assignment/assignment.actions";
import {
  selectErrorFetchingResults, selectErrorFetchingStudentPoints, selectIsFetchingResults, selectIsFetchingStudentPoints, selectResultData,
  selectResultLoadMore, selectResultsOffset, selectStudentPointsData
} from "redux/assignment/assignment.selectors";
import { commonStrigns, stringFiles } from "res/strings";
import { createStructuredSelector } from "reselect";
import { Box } from "styled-components/box";
import { SkeletonLine } from "styled-components/skeleton/SkeletonLine";
import { CookieUtils } from "utils";
import ResultCard from "../../components/assignment/ResultCard";


const Result = ({ t }) => {
  const [show, setShow] = useState(true);

  const dispatch = useDispatch();
  const router = useRouter();

  const cookieInstance = new CookieUtils();

  const studentID = cookieInstance.getCookie("studentID");
  const semesterID = cookieInstance.getCookie("semesterID");

  const {
    resultData,
    isFetchingResults,
    errorFetchingResults,
    resultLoadMore,
    resultOffset,
    currentUser,
    //student Points
    studentPointsData,
    isFetchingstudentPoints,
    errorFetchingstudentPoints,
  } = useSelector(
    createStructuredSelector({
      resultData: selectResultData,
      isFetchingResults: selectIsFetchingResults,
      errorFetchingResults: selectErrorFetchingResults,
      resultLoadMore: selectResultLoadMore,
      resultOffset: selectResultsOffset,
      //studentPoint
      studentPointsData: selectStudentPointsData,
      isFetchingstudentPoints: selectIsFetchingStudentPoints,
      errorFetchingstudentPoints: selectErrorFetchingStudentPoints,
      // USER
    })
  );

  useEffect(() => {
    dispatch(resetResultOffset());
    getData();
  }, []);

  const getResultList = () => {
    dispatch(getResultsStartAsync({ studentID, semesterID, isShowArchived: false }));
  };

  const getData = () => {
    getResultList()
    dispatch(getStundetPointsStartAsync({ studentID, semesterID }));
  };

  return (
    <Box
      style={{ backgroundColor: "#F5F5F5" }}
      className="w-100 d-flex flex-column"
    >
      {(isFetchingResults || isFetchingstudentPoints) && !resultLoadMore ? (
        //Loading
        <>
          {[1, 2, 3, 4, 5, 6].map((item, idx) => (
            <Box key={idx} width="100%" height="50px" className="my-1">
              <SkeletonLine />
            </Box>
          ))}
        </>
      ) : resultData &&
        studentPointsData &&
        !errorFetchingResults &&
        !errorFetchingstudentPoints ? (
        //Show Data

        <>

          {studentPointsData && (
            <PointsComponent
              pointsEarned={studentPointsData.pointsEarned}
              pointsPercent={studentPointsData.pointsPercent}
              totalPoints={studentPointsData.totalPoints}
            />
          )}
          <InfiniteScroll
            dataLength={resultData.length} //This is important field to render the next data
            next={() => getResultList()}
            hasMore={resultLoadMore}
            loader={
              <Spinner
                className="d-flex mx-auto align-self-center"
                animation="border"
              />
            }
            // endMessage={
            //   <p className="text-success" style={{ textAlign: 'center' }}>
            //     {t(AssignmentString.listFinish)}
            //   </p>
            // }
            // below props only if you need pull down functionality
            refreshFunction={() => {
              dispatch(resetResultOffset());
              getData();
            }}
            pullDownToRefresh
            pullDownToRefreshThreshold={100}
            pullDownToRefreshContent={
              <p style={{ textAlign: "center" }}>دریافت مجدد لیست</p>
            }
            releaseToRefreshContent={
              <p style={{ textAlign: "center" }}>دریافت مجدد لیست</p>
            }
            className="px-2"
          >
            {resultData.map((assignment, id) => (
              <ResultCard {...assignment} duration={false} key={id} />
            ))}
          </InfiniteScroll>

          {resultData.length === 0 && (
            <h3 className="text-center mt-5 app-text-gray">
              نتیجه ای برای شما ثبت نشده است
            </h3>
          )}
          {!resultLoadMore && <Button className="d-flex justify-content-center w-50 mx-auto my-1" onClick={() => {
            router.push(`/assignment/archive`)
          }}>
            آرشیو نتایج
          </Button>}
        </>
      ) : (
        //Error
        <Alert show={show} variant="danger">
          <Alert.Heading>{t(commonStrigns.error)}</Alert.Heading>
          <p>{errorFetchingResults || errorFetchingstudentPoints}</p>
          <hr />
          <div>
            <Button onClick={() => getData()} variant="outline-danger">
              {t(commonStrigns.retry)}
            </Button>
          </div>
        </Alert>
      )}
    </Box>
  );
};

const PointsComponent = ({ totalPoints, pointsEarned, pointsPercent }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: 150 }}
    >
      <div
        style={{
          height: 80,
          borderTop: "2px solid #dee2e6",
          borderBottom: "2px solid  #dee2e6",
        }}
        className="d-flex w-100 bg-light align-items-center justify-content-center my-1"
      >
        <div className="d-flex flex-column  app-flex-1 justify-content-center align-items-center">
          <p className="m-0 app-text-xs">امتیاز کسب شده</p>
          <p className="m-0 text-primary">{pointsEarned}</p>
        </div>

        <div className="d-flex flex-column  app-flex-1 justify-content-center align-items-center">
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "50px",
              width: 100,
              height: 100,
            }}
          >
            <CircularProgressbar
              value={Number.parseFloat(pointsPercent).toFixed(2)}
              text={`${Number.parseFloat(pointsPercent).toFixed(2)}%`}
            />
          </div>
        </div>

        <div className="d-flex flex-column  app-flex-1 justify-content-center align-items-center">
          <p className="m-0 app-text-xs">امتیاز کل</p>
          <p style={{ color: "#C4C5C6" }} className="m-0">
            {totalPoints}
          </p>
        </div>
      </div>
    </div>
  );
};

export default withTranslation(stringFiles.common)(Result);
